export default "__VITE_ASSET__DEg21p_r__"